import React from 'react'
import ProductNike from './ProductNike'
import { NavLink } from 'react-router-dom'

const Home = () => {
    return (
        <div>
            <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>
                </div>
                {/* class="d-block w-100" "img-fluid" */}
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <img src="/assets/images/bg/bg1.jpg" class="d-block w-100" height="500px" alt=""/>                        
    </div>
                        <div class="carousel-item">
                            <img src="/assets/images/bg/bg2.jpg" class="d-block w-100" height="500px" alt=""/>
    </div>
                            <div class="carousel-item">
                                <img src="/assets/images/bg/bg3.jpg" class="d-block w-100" height="500px" alt=""/>
    </div>
                            <div class="carousel-item">
                                <img src="/assets/images/bg/bg4.jpg" class="d-block w-100" height="500px" alt=""/>
    </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                        <ProductNike/>
                        <div align="center" className="container">
                        <NavLink to="/products"><button className="btn btn-outline-dark mb-5 w-25  mx-auto">⇓ View All Products ⇓</button></NavLink>
                        {/*<NavLink to="/products"><button className="btn btn-outline-dark mb-5 w-25  mx-auto">View All Products</button></NavLink>*/}

                        </div>
                    </div>
                    )
}

export default Home
